import script from "./NewHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./NewHeader.vue?vue&type=script&setup=true&lang=js"

import "./NewHeader.vue?vue&type=style&index=0&id=39cfa6ce&lang=css"
import "./NewHeader.vue?vue&type=style&index=1&id=39cfa6ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39cfa6ce"]])

export default __exports__